import React, { useEffect } from "react";
import { Link, Form, useNavigate } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import {
    Container,
    Row,
    Col,
    Card,
    Button,
    FormGroup,
    FormCheck,
} from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";

import { authActions } from "../../../features/auth/authSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { displayFormAlert } from "../../../lib/utils";
import { ICredentials } from "../../../types/users";

const Login = () => {
    const { loading, user, loggedIn } = useAppSelector(state => state.auth);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const loginSchema = yup.object().shape({
        email: yup
            .string()
            .required("Email address is required")
            .email("Email is invalid"),
        password: yup.string().required("Password is required"),
        remember: yup.boolean().optional(),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(loginSchema),
    });

    const onSubmit: SubmitHandler<ICredentials> = ({
        email,
        password,
        remember,
    }) => {
        dispatch(authActions.login({ email, password, remember }));
    };

    useEffect(() => {
        if (loggedIn) {
            navigate("/profile");
        }
    }, [navigate, user, loggedIn]);

    return (
        <div data-testid="loginContent">
            <Container>
                <Row className="justify-content-center">
                    <Col lg="6" md="9">
                        <Card className="o-hidden border-0 shadow-lg my-5">
                            <Card.Body className="p-0">
                                <Row>
                                    <Col className="p-5">
                                        <div className="text-center">
                                            <h2 className="text-gray-900 mb-4">
                                                Login
                                            </h2>
                                        </div>
                                        <Form
                                            method="post"
                                            replace
                                            className="user"
                                            id="login"
                                            onSubmit={handleSubmit(onSubmit)}
                                        >
                                            <FormGroup className="form-group">
                                                <input
                                                    type="email"
                                                    placeholder="Enter Email Address..."
                                                    className="form-control form-control-user"
                                                    {...register("email")}
                                                />
                                                {errors.email &&
                                                    displayFormAlert({
                                                        level: "danger",
                                                        text: errors.email
                                                            .message as string,
                                                    })}
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <input
                                                    type="password"
                                                    placeholder="Password"
                                                    className="form-control form-control-user"
                                                    {...register("password")}
                                                />
                                                {errors.password &&
                                                    displayFormAlert({
                                                        level: "danger",
                                                        text: errors.password
                                                            .message as string,
                                                    })}
                                            </FormGroup>
                                            <FormGroup className="form-group">
                                                <FormCheck
                                                    id="remember"
                                                    label="Remember me"
                                                    {...register("remember")}
                                                />
                                            </FormGroup>
                                            <Button
                                                disabled={loading}
                                                variant="primary"
                                                type="submit"
                                            >
                                                {loading
                                                    ? "Logging in..."
                                                    : "Sign in"}
                                            </Button>
                                        </Form>
                                        <hr />
                                        <div className="text-center">
                                            <p className="small">
                                                <Link to="/lost-password">
                                                    Lost your password?
                                                </Link>
                                            </p>
                                            <p>
                                                Don't have an account?{" "}
                                                <Link to="/register">
                                                    Create one now
                                                </Link>
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Login;
